import {getField, updateField} from 'vuex-map-fields';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    affiliation: null,
  };
}

const state = initialState ();

// actions
const actions = {
    async create (context, payload) {
      var response = await API.affiliation.create (payload);
      //update list after affiliation is created
      await context.dispatch ('list');
      return response;
    },

    async get (context, payload) {
      var affiliation = context.getters['getAffiliation'] (payload.id);
      /* if not in state get from api */
      if (affiliation == undefined) {
        var response = await API.affiliation.get (payload);
        affiliation = response.affiliation;
      }
      return affiliation;
    },

    async delete (context, payload) {
      var response = await API.affiliation.delete (payload);
      return response;
    },

    async list (context, payload) {
      var response = await API.affiliation.list (payload);
      // set affiliations in list
      context.commit ('set_list', response);
      return response;
    },

    async update (context, payload) {
      var response = await API.affiliation.update (payload);
      await context.dispatch ('list');
      return response;
    },
};

// getters
const getters = {
    getField,
    getAffiliation: state => id => {
      var affiliation = null;
      if (state.list.length) {
        affiliation = state.list.find (affiliation => {
          return affiliation.id == id;
        });
      }
      return affiliation;
    },
};

  // mutations
const mutations = {
    updateField,
    set_list (state, payload) {
      state.list = payload.affiliations.data;
    },
    reset (state) {
      // acquire initial state
      const s = initialState ();
      Object.keys (s).forEach (key => {
        state[key] = s[key];
      });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
